var exports = {
  "k": "x52a3aa3b--680c5a--container",
  "r": "x52a3aa3b--680c5a--container--pill",
};

module.exports = exports;
